import React from "react"
import {ManagedSolutionsCard} from "../../../containers/ManagedSolutionsCard/ManagedSolutionsCard"
import {TaskCardList} from "../../TaskCardList/TaskCardList"
import {TaskCardItem} from "../../TaskCard/types"
import classNames from "classnames"

interface GettingStartedCardProps {
	tasks: TaskCardItem[]
	className?: string
	defaultExpanded?: boolean
}

export function GettingStartedCard({tasks, className, defaultExpanded = true}: GettingStartedCardProps) {
	return (
		<ManagedSolutionsCard
			title="Getting started"
			collapsible
			collapsedText="Take action setting up your business to launch"
			defaultExpanded={defaultExpanded}
			className={classNames("managed-solutions-card-getting-started", className)}
			backgroundClassName="getting-started-card-bg"
			withShadow
		>
			<TaskCardList tasks={tasks} />
		</ManagedSolutionsCard>
	)
}
